import { getRebuyApiKey, getRebuyVisitorUuid } from './rebuy-helpers.js';

class RebuyProductView extends HTMLElement {
  static trackedProducts = new Set();

  static pendingProducts = new Set();

  constructor() {
    super();

    this.tracked = false;
  }

  connectedCallback() {
    if (this.tracked) return;

    this.trackProductView().catch((error) => {
      console.error('[RebuyProductView] Unable to track product view', error);
    });
  }

  async trackProductView() {
    const productId = this.dataset.productId;
    const customerId = this.dataset.customerId || '';
    const apiKey = getRebuyApiKey();
    const uuid = getRebuyVisitorUuid();

    if (
      !productId ||
      !apiKey ||
      !uuid ||
      RebuyProductView.trackedProducts.has(productId) ||
      RebuyProductView.pendingProducts.has(productId)
    ) {
      return;
    }

    RebuyProductView.pendingProducts.add(productId);

    try {
      const response = await fetch('https://rebuyengine.com/api/v2/analytics/event', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Rebuy-User-Token': apiKey,
        },
        body: JSON.stringify({
          subject: 'user',
          verb: 'viewed',
          noun: 'product',
          uuid,
          product_id: String(productId),
          ...(customerId ? { customer_id: String(customerId) } : {}),
        }),
      });

      if (!response.ok) {
        throw new Error(`Analytics request failed with ${response.status}`);
      }

      RebuyProductView.trackedProducts.add(productId);
      this.tracked = true;
    } finally {
      RebuyProductView.pendingProducts.delete(productId);
    }
  }
}

if (!customElements.get('rebuy-product-view')) {
  customElements.define('rebuy-product-view', RebuyProductView);
}
